/**
 * 手机号中间四位显示为星号
 * @param {string} mobile 手机号
 * @returns {string} 格式化后的手机号
 */
export function formatMobile(mobile) {
    if (!mobile) return ''
    return mobile.replace(/(\d{3})\d{4}(\d{4})/, '$1****$2')
}

export default {
    formatMobile
} 